// Português.
export default {
    'canvas.title': 'Conteúdo da página',
    'canvas.loading': 'A carregar o editor…',
    'empty.title': 'Comece a sua página',
    'empty.text': 'Arraste para aqui um bloco ou uma secção pronta, ou clique num deles para o adicionar.',
    'empty.sections': 'Ver as secções',
    'empty.blocks': 'Adicionar um bloco',

    'panel.insert': 'Adicionar',
    'panel.settings': 'Definições',
    'panel.content': 'Conteúdo',
    'panel.layout': 'Layout',
    'panel.style': 'Estilo',
    'panel.visibility': 'Visibilidade',
    'panel.advanced': 'Avançado',
    'tab.blocks': 'Blocos',
    'tab.sections': 'Secções',
    'tab.layers': 'Camadas',
    'category.layout': 'Layout',
    'category.basic': 'Básicos',
    'category.media': 'Multimédia',
    'category.components': 'Componentes',
    'category.advanced': 'Avançado',
    'palette.hint': 'Arraste para a página ou clique para adicionar',
    'palette.none': 'Nenhum bloco corresponde à sua pesquisa.',
    'sections.intro': 'Arraste uma secção para a página ou clique para a adicionar. Tudo continua editável.',
    'layers.empty': 'A página está vazia.',
    'inspector.empty': 'Selecione um bloco da página para editar o seu conteúdo e estilo.',
    'inspector.path': 'Posição na página',

    'device.label': 'Tamanho da pré-visualização',
    'device.desktop': 'Computador',
    'device.tablet': 'Tablet',
    'device.mobile': 'Telemóvel',

    'action.undo': 'Anular',
    'action.redo': 'Refazer',
    'action.guides': 'Mostrar os contornos dos blocos',
    'action.preview': 'Pré-visualizar',
    'action.code': 'Editar o código',
    'action.copyCode': 'Copiar o código',
    'action.fullscreen': 'Ecrã inteiro',
    'action.selectParent': 'Selecionar o bloco pai',
    'action.move': 'Arrastar para mover',
    'action.moveUp': 'Subir',
    'action.moveDown': 'Descer',
    'action.duplicate': 'Duplicar',
    'action.remove': 'Eliminar',
    'action.close': 'Fechar',
    'action.apply': 'Aplicar',
    'action.cancel': 'Cancelar',
    'action.clear': 'Limpar',
    'action.search': 'Pesquisar',
    'action.searchBlocks': 'Pesquisar um bloco…',
    'action.addColumn': 'Adicionar uma coluna',
    'action.equalize': 'Larguras iguais',
    'action.addButton': 'Adicionar um botão',
    'action.addItem': 'Adicionar um item',
    'action.resizeColumns': 'Arrastar para redimensionar as colunas',
    'category.saved': 'Guardados',
    'action.saveBlock': 'Guardar como bloco reutilizável',
    'action.save': 'Guardar',
    'action.restore': 'Restaurar',
    'saved.name': 'Nome do bloco',
    'saved.help': 'O bloco e todo o seu conteúdo ficarão disponíveis em Blocos › Guardados, para esta página e as seguintes.',
    'saved.done': 'Bloco guardado: encontra-o em Blocos › Guardados.',
    'saved.remove': 'Remover este bloco guardado',
    'notice.draftFound': 'As alterações de {date} não foram guardadas.',
    'error.storage': 'O navegador não conseguiu guardar este bloco (armazenamento cheio ou desativado).',

    'shortcut.undo': 'anular',
    'shortcut.duplicate': 'duplicar',
    'shortcut.move': 'subir ou descer',
    'shortcut.remove': 'eliminar',
    'shortcut.parent': 'selecionar o pai',
    'shortcut.edit': 'editar o texto',

    'block.container': 'Contentor',
    'block.containerFluid': 'Largura total',
    'block.box': 'Caixa',
    'block.row': 'Linha',
    'block.col': 'Coluna',
    'block.heading': 'Título',
    'block.text': 'Texto',
    'block.quote': 'Citação',
    'block.list': 'Lista',
    'block.table': 'Tabela',
    'block.button': 'Botão',
    'block.separator': 'Separador',
    'block.spacer': 'Espaço',
    'block.icon': 'Ícone',
    'block.html': 'HTML',
    'block.image': 'Imagem',
    'block.video': 'Vídeo',
    'block.embed': 'Página incorporada',
    'block.map': 'Mapa',
    'block.card': 'Cartão',
    'block.accordion': 'Acordeão',
    'preset.cols1': '1 coluna',
    'preset.cols2': '2 colunas',
    'preset.cols3': '3 colunas',
    'preset.cols4': '4 colunas',
    'preset.cols84': '2/3 + 1/3',
    'preset.cols48': '1/3 + 2/3',
    'preset.cols363': '1/4 + 1/2 + 1/4',
    'preset.cols6': '6 colunas',

    'placeholder.heading': 'O seu título',
    'placeholder.text': 'Escreva aqui o seu texto. Selecione palavras para as pôr a negrito, em itálico ou como ligação.',
    'placeholder.quote': 'Uma boa citação, curta e memorável.',
    'placeholder.author': 'Nome do autor',
    'placeholder.item': 'Item',
    'placeholder.column': 'Coluna',
    'placeholder.button': 'Clique aqui',
    'placeholder.readMore': 'Ler mais',
    'placeholder.caption': 'Legenda da imagem',
    'placeholder.cardTitle': 'Título do cartão',
    'placeholder.cardText': 'Uma breve descrição que dá vontade de saber mais.',
    'placeholder.question': 'Pergunta',
    'placeholder.answer': 'A resposta, em poucas frases claras.',
    'placeholder.html': 'O seu código HTML',
    'placeholder.address': 'Torre Eiffel, Paris',

    'field.width': 'Largura',
    'field.tag': 'Etiqueta HTML',
    'field.gutters': 'Espaço entre colunas',
    'field.justify': 'Alinhamento horizontal',
    'field.alignItems': 'Alinhamento vertical',
    'field.alignSelf': 'Alinhamento vertical na linha',
    'field.columnWidth': 'Largura por tamanho de ecrã',
    'field.level': 'Nível',
    'field.size': 'Tamanho',
    'field.thickness': 'Espessura',
    'field.opacity': 'Opacidade',
    'field.height': 'Altura',
    'field.icon': 'Ícone',
    'field.filled': 'Preenchido',
    'field.image': 'Imagem',
    'field.alt': 'Texto alternativo',
    'field.link': 'Ligação',
    'field.newTab': 'Abrir num novo separador',
    'field.caption': 'Legenda',
    'field.align': 'Alinhamento',
    'field.ratio': 'Proporções',
    'field.corners': 'Cantos',
    'field.shadow': 'Sombra',
    'field.videoUrl': 'Vídeo',
    'field.controls': 'Mostrar os controlos',
    'field.autoplay': 'Reprodução automática (sem som)',
    'field.loop': 'Em ciclo',
    'field.muted': 'Sem som',
    'field.url': 'Endereço (URL)',
    'field.address': 'Morada',
    'field.zoom': 'Zoom',
    'field.showImage': 'Mostrar uma imagem',
    'field.titleLevel': 'Nível do título',
    'field.showButton': 'Mostrar um botão',
    'field.firstOpen': 'Primeiro item aberto',
    'field.items': 'Itens',
    'field.question': 'Pergunta',
    'field.text': 'Texto',
    'field.style': 'Estilo',
    'field.code': 'Código HTML',
    'field.textAlign': 'Alinhamento do texto',
    'field.spacing': 'Espaçamentos',
    'field.margin': 'Margem exterior',
    'field.padding': 'Margem interior',
    'field.background': 'Fundo',
    'field.backgroundImage': 'Imagem de fundo',
    'field.textColor': 'Cor do texto',
    'field.border': 'Contorno',
    'field.showOn': 'Mostrar em',
    'field.id': 'Âncora (ID)',
    'field.classes': 'Classes CSS',
    'field.inlineStyle': 'Estilo em linha',
    'side.t': 'em cima',
    'side.b': 'em baixo',
    'side.s': 'à esquerda',
    'side.e': 'à direita',

    'help.alt': 'Descreve a imagem a quem não a vê e aos motores de pesquisa.',
    'help.video': 'Uma ligação do YouTube ou Vimeo, ou o endereço de um ficheiro MP4.',
    'help.embed': 'O endereço de uma página que aceita ser incorporada (um formulário, um calendário…).',
    'help.columnWidth': 'Primeiro o telemóvel: um tamanho vazio usa o do ecrã mais pequeno, mostrado a cinzento.',
    'help.visibility': 'Desmarque um tamanho para ocultar o bloco nesses ecrãs.',
    'help.id': 'Permite que uma ligação aponte para este bloco: #ancora.',
    'help.classes': 'Classes do seu tema ou do Bootstrap, separadas por espaços.',
    'help.accordion': 'Clique numa pergunta ou resposta na página para editar o seu texto.',
    'help.html': 'Os scripts e os atributos de evento são removidos por segurança.',

    'option.default': 'Predefinido',
    'option.none': 'Nenhum',
    'option.auto': 'Auto',
    'option.fill': 'Preencher',
    'option.inherit': 'Herdar',
    'option.custom': 'Cor personalizada',
    'option.boxed': 'Centrado',
    'option.fullWidth': 'Largura total',
    'option.start': 'Esquerda',
    'option.center': 'Centro',
    'option.end': 'Direita',
    'option.between': 'Distribuído',
    'option.top': 'Em cima',
    'option.middle': 'Ao meio',
    'option.bottom': 'Em baixo',
    'option.wrapLeft': 'À esquerda, texto à volta',
    'option.wrapRight': 'À direita, texto à volta',
    'option.original': 'Original',
    'option.square': 'Retos',
    'option.rounded': 'Arredondados',
    'option.pill': 'Pílula',
    'option.circle': 'Círculo',
    'option.small': 'Pequena',
    'option.medium': 'Média',
    'option.large': 'Grande',
    'button.primary': 'Principal',
    'button.outline-primary': 'Principal, contorno',
    'button.secondary': 'Secundário',
    'button.outline-secondary': 'Secundário, contorno',
    'button.success': 'Sucesso',
    'button.outline-success': 'Sucesso, contorno',
    'button.danger': 'Perigo',
    'button.outline-danger': 'Perigo, contorno',
    'button.warning': 'Aviso',
    'button.outline-warning': 'Aviso, contorno',
    'button.info': 'Info',
    'button.outline-info': 'Info, contorno',
    'button.light': 'Claro',
    'button.outline-light': 'Claro, contorno',
    'button.dark': 'Escuro',
    'button.outline-dark': 'Escuro, contorno',
    'button.link': 'Ligação',

    'rte.toolbar': 'Formatação do texto',
    'rte.format': 'Estilo do parágrafo',
    'rte.paragraph': 'Parágrafo',
    'rte.lead': 'Destaque',
    'rte.small': 'Texto pequeno',
    'rte.table': 'Tabela…',
    'rte.rowAbove': 'Inserir uma linha acima',
    'rte.rowBelow': 'Inserir uma linha abaixo',
    'rte.colLeft': 'Inserir uma coluna à esquerda',
    'rte.colRight': 'Inserir uma coluna à direita',
    'rte.deleteRow': 'Eliminar a linha',
    'rte.deleteCol': 'Eliminar a coluna',
    'rte.deleteTable': 'Eliminar a tabela',
    'rte.heading': 'Título {n}',
    'rte.quote': 'Citação',
    'rte.code': 'Código',
    'rte.bold': 'Negrito (Ctrl+B)',
    'rte.italic': 'Itálico (Ctrl+I)',
    'rte.underline': 'Sublinhado (Ctrl+U)',
    'rte.strike': 'Rasurado',
    'rte.link': 'Ligação (Ctrl+K)',
    'rte.unlink': 'Remover a ligação',
    'rte.bulletList': 'Lista com marcadores',
    'rte.numberedList': 'Lista numerada',
    'rte.alignLeft': 'Alinhar à esquerda',
    'rte.alignCenter': 'Centrar',
    'rte.alignRight': 'Alinhar à direita',
    'rte.justify': 'Justificar',
    'rte.clear': 'Limpar a formatação',

    'media.upload': 'Carregar',
    'media.library': 'Escolher',
    'media.urlOnly': 'Cole o endereço do ficheiro. Enviar ficheiros do computador requer um endereço de carregamento (opção uploadUrl).',
    'media.embedded': 'Imagem guardada na página',

    'code.title': 'Código HTML da página',
    'code.help': 'Edite o código e aplique-o: o PageFlow reencontra os seus blocos. Os scripts são removidos.',

    'notice.copied': 'Código copiado para a área de transferência',
    'notice.noGrid': 'Os estilos do site não foram carregados no editor: entretanto é usada uma grelha simples. Verifique a opção canvasStyles.',
    'notice.codeApplied': 'Código aplicado',
    'notice.cannotInsert': 'Este bloco não pode ficar aqui. Selecione primeiro uma coluna ou um contentor.',
    'error.copy': 'Não foi possível copiar o código. Selecione-o na vista do código.',
    'error.fileType': 'Este tipo de ficheiro não é aceite aqui.',
    'error.fileSize': 'Este ficheiro é demasiado grande (máximo {size} MB).',
    'error.upload': 'Não foi possível carregar o ficheiro.',
    'error.noUpload': 'Não está definido nenhum endereço de carregamento: os ficheiros do computador não podem ser enviados. Cole antes o endereço do ficheiro (programadores: opção uploadUrl, gestor PHP incluído).',

    'sec.heroSplit': 'Destaque com imagem',
    'sec.heroSplitDesc': 'Título, texto e botões ao lado de uma foto.',
    'sec.heroCenter': 'Destaque centrado',
    'sec.heroCenterDesc': 'Uma grande mensagem centrada numa faixa clara.',
    'sec.features': 'Pontos fortes',
    'sec.featuresDesc': 'Três pontos fortes com ícones.',
    'sec.imageText': 'Imagem e texto',
    'sec.imageTextDesc': 'Uma foto ao lado de um texto e de uma lista.',
    'sec.cta': 'Chamada à ação',
    'sec.ctaDesc': 'Uma faixa colorida com um botão claro.',
    'sec.cards': 'Cartões',
    'sec.cardsDesc': 'Três artigos, produtos ou serviços.',
    'sec.testimonials': 'Testemunhos',
    'sec.testimonialsDesc': 'O que os seus clientes dizem de si.',
    'sec.pricing': 'Preços',
    'sec.pricingDesc': 'Três planos lado a lado.',
    'sec.faq': 'Perguntas frequentes',
    'sec.faqDesc': 'Perguntas e respostas que abrem com um clique.',
    'sec.stats': 'Números-chave',
    'sec.statsDesc': 'Quatro números que inspiram confiança.',
    'sec.team': 'Equipa',
    'sec.teamDesc': 'Retratos com nomes e funções.',
    'sec.contact': 'Contactos',
    'sec.contactDesc': 'Morada, telefone e e-mail ao lado de um mapa.',
    'sec.gallery': 'Galeria',
    'sec.galleryDesc': 'Seis fotos em grelha.',
    'sec.heroTitle': 'Crie páginas bonitas em minutos',
    'sec.heroText': 'Arraste, largue e escreva: a sua página está pronta, adaptada a telemóveis e limpa, sem uma única linha de código.',
    'sec.getStarted': 'Começar',
    'sec.learnMore': 'Saber mais',
    'sec.contactUs': 'Contacte-nos',
    'sec.imageAlt': 'Foto',
    'sec.centerTitle': 'Tudo o que precisa, nada a mais',
    'sec.centerText': 'Uma promessa simples que diz aos visitantes que estão no sítio certo.',
    'sec.featuresTitle': 'Porquê escolher-nos',
    'sec.featuresText': 'Três boas razões, em poucas palavras.',
    'sec.feature1': 'Rápido',
    'sec.feature2': 'Fiável',
    'sec.feature3': 'Pensado para telemóveis',
    'sec.featureText': 'Descreva este ponto forte numa ou duas frases que falem aos seus visitantes.',
    'sec.imageTextTitle': 'Conte a sua história',
    'sec.imageTextText': 'Explique o que faz e como ajuda, com as palavras dos seus clientes.',
    'sec.point1': 'Uma primeira vantagem',
    'sec.point2': 'Uma segunda vantagem',
    'sec.point3': 'Uma terceira vantagem',
    'sec.ctaTitle': 'Pronto para começar?',
    'sec.ctaText': 'Junte-se a quem já confia em nós. Leva apenas um minuto.',
    'sec.cardsTitle': 'Últimas notícias',
    'sec.cardTitle': 'Um título de cartão',
    'sec.cardText': 'Um breve resumo que dá vontade de continuar a ler.',
    'sec.readMore': 'Ler mais',
    'sec.testimonialsTitle': 'O que dizem os nossos clientes',
    'sec.quote1': 'Simples, rápido e bonito. Refizemos todo o nosso site num fim de semana.',
    'sec.quote2': 'O suporte respondeu em menos de uma hora. Recomendo sem hesitar.',
    'sec.quote3': 'Desde as novas páginas, os visitantes ficam mais tempo e contactam-nos mais vezes.',
    'sec.name1': 'Emma Lawson',
    'sec.name2': 'Lucas Martins',
    'sec.name3': 'Sofia Rossi',
    'sec.role1': 'Fundadora, Studio Norte',
    'sec.role2': 'Gerente, Porto Azul',
    'sec.role3': 'Diretora, Atelier Verde',
    'sec.pricingTitle': 'Preços simples',
    'sec.pricingText': 'Sem custos escondidos. Mude ou cancele quando quiser.',
    'sec.plan1': 'Essencial',
    'sec.plan2': 'Profissional',
    'sec.plan3': 'Empresa',
    'sec.month': 'mês',
    'sec.benefit1': 'Uma primeira vantagem',
    'sec.benefit2': 'Uma segunda vantagem',
    'sec.benefit3': 'Uma terceira vantagem',
    'sec.choose': 'Escolher este plano',
    'sec.faqTitle': 'Perguntas frequentes',
    'sec.question1': 'Como começo?',
    'sec.answer1': 'Escolha um plano, crie a sua conta e siga o guia: bastam poucos minutos.',
    'sec.question2': 'Posso mudar de plano mais tarde?',
    'sec.answer2': 'Sim, a qualquer momento. A diferença é calculada por si.',
    'sec.question3': 'Oferecem apoio?',
    'sec.answer3': 'A nossa equipa responde por e-mail em todos os dias úteis.',
    'sec.question4': 'Os meus dados estão seguros?',
    'sec.answer4': 'Os seus dados são guardados em segurança e nunca partilhados.',
    'sec.stat1': 'clientes satisfeitos',
    'sec.stat2': 'de satisfação',
    'sec.stat3': 'apoio',
    'sec.stat4': 'países',
    'sec.teamTitle': 'A equipa',
    'sec.member': 'Membro da equipa',
    'sec.jobTitle': 'Função',
    'sec.contactTitle': 'Fale connosco',
    'sec.contactText': 'Teremos todo o gosto em ouvi-lo. Escreva-nos ou venha visitar-nos.',
    'sec.addressLabel': 'Morada',
    'sec.address': '5 Avenue Anatole France, 75007 Paris',
    'sec.phoneLabel': 'Telefone',
    'sec.emailLabel': 'E-mail',
    'sec.galleryTitle': 'Galeria',
};
